module.exports = __webpack_public_path__ + "static/favicon-96x96-8dd5874ef7a9be03e2fdd1b6436a4c30.png";